import {useState} from 'preact/hooks';
import cn from 'classnames';

import {Segmented, NormalSpanBtn, ArrowBtn} from './components';
import {modelsService as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

import styles from '~/style/aigallery/modelsService.module.less';
import styleCom from '~/style/aigallery/common.module.less';

import {ArrowRightSvg} from '~/assets/qf/iconSvg';

const id = 'modelsService';

const ModelsService = () => {
    const {title, tabsNav, content, bottomBtn, onlineTest} = data;
    const [active, setActive] = useState(tabsNav[0].value);
    const [isFocused, setIsFocused] = useState(false);
    const [isHover, setHover] = useState(false);
    const [question, setQuestion] = useState('');
    const [onlineModel, setOnlineModel] = useState(onlineTest?.selectOptions[0]);

    useCptDuration(id, {
        name: `${applicationName}-高效价比的模型服务-停留时长`
    });
    const navToOnline = () => {
        if (typeof window !== 'undefined' && question.trim().length > 0) {
            window?.open?.(
                // eslint-disable-next-line max-len
                `${onlineModel.link}?question=${encodeURIComponent(question)}`
            );
        }
    };

    return (
        <div className={styles['models-service']} id={id}>
            <div className={styles['models-service-online-test']}>
                <h2 className={`${moduleTitleCn} ${styles.title}`}>{title}</h2>
                <div className={`${moduleContentCn} ${styles['video-box']}`}>
                    <video muted autoPlay loop playsinline="true" webkit-playsinline="true">
                        <source src={require('../../../assets/qf/models/video.mp4').default} type="video/mp4" />
                    </video>
                </div>
                <div className={cn(styles['input-box'])}>
                    {/* 输入对话框 */}
                    <div
                        className={`${styles['input-box-input']} ${isFocused ? styles['input-box-input-fucus'] : styles['input-box-input-noFucus']}`}
                    >
                        <div className={styles['input-box-input-main']}>
                            <div className={styles['input-box-input-content']}>
                                <textarea
                                    id="code-input"
                                    className={styles['code-input']}
                                    // autoFocus
                                    onFocus={() => {
                                        setIsFocused(true);
                                    }}
                                    onBlur={() => {
                                        setIsFocused(false);
                                    }}
                                    placeholder={'请输入问题，例如请帮我做一份北京7天的旅行规划。'}
                                    rows={1}
                                    value={question}
                                    onChange={e => {
                                        setQuestion(e.target.value);
                                    }}
                                />
                                {question?.length > 100 ? (
                                    <div className={styles['text-length']}>{question?.length}/100</div>
                                ) : null}
                            </div>
                            {/* 操作 */}
                            <div className={styles['input-box-input-opera']}>
                                <div
                                    className={
                                        styles[
                                            `${isHover ? 'input-box-input-opera-send' : 'input-box-input-opera-send-noHover'}`
                                        ]
                                    }
                                    onMouseEnter={() => {
                                        setHover(true);
                                    }}
                                    onMouseLeave={() => {
                                        setHover(false);
                                    }}
                                >
                                    <span className={styles['input-box-input-opera-send-dropdown-item']}>
                                        <img src={onlineModel.icon} alt="模型icon" />
                                        <span class={styles['input-box-input-opera-send-dropdown-item-text']}>
                                            {onlineModel.label}
                                        </span>
                                        {ArrowRightSvg}
                                    </span>
                                    <div className={styles['acud-dropdown-placement-bottomLeft']} style={{
                                        height: `${(onlineTest?.selectOptions.length ?? 0) * 36 + 57}PX`,
                                    }}>
                                        <div>
                                            {onlineTest?.selectOptions.map(item => {
                                                return (
                                                    <div
                                                        onClick={() => {
                                                            setOnlineModel(item);
                                                            setHover(false);
                                                        }}
                                                        key={item.key}
                                                        className={`${styles['acud-dropdown-menu-item']} ${item.label === onlineModel.label ? styles['acud-dropdown-menu-item-active'] : ''}`}
                                                    >
                                                        <div>
                                                            <img src={item.icon} alt="" />
                                                            <div>{item.label}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={
                                        styles[
                                            question.trim()?.length > 0
                                                ? 'input-box-input-opera-haveQuestion'
                                                : 'input-box-input-opera-noQuestion'
                                        ]
                                    }
                                    onClick={navToOnline}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={cn(styleCom['modules-padding'], `${moduleContentCn}`, `${styles.navBox}`)}
                style={{
                    zIndex: isHover ? 10 : 12,
                    position: 'relative'
                }}
            >
                <Segmented options={tabsNav} value={active} onChange={setActive} />
            </div>
            <div className={cn(styleCom['modules-padding'], `${moduleContentCn}`)}>
                <div className={styles['model-card-wrapper']}>
                    {content[active]?.map((item, index) => {
                        const tagArr = [...item.tags, ...item.type];
                        const href = item.btn.link;
                        return (
                            <a
                                key={index}
                                className={cn(styles['model-card'])}
                                href={href}
                                target="_blank"
                                {...item.btn.trackInfo}
                            >
                                <div className={styles['model-icon-name']}>
                                    <img src={item.icon} alt="模型icon" />
                                    <div className={styles.name}>{item.name}</div>
                                </div>
                                <div className={styles['tag-wrapper']}>
                                    {tagArr.map((it, inx) => {
                                        return (
                                            <span key={inx} className={cn(styles.tag, {[styles.primary]: it.type})}>
                                                {it.label}
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className={styles.info}>
                                    <p className={styles.desc}>{item.desc}</p>
                                    <div className={cn(styles.vertical, styles.context)}>
                                        <div className={styles.left}>
                                            <span className={styles.label}>模型接入点</span>
                                            <span className={styles.value}>{item.accessPoint}</span>
                                        </div>
                                        <div className={styles.right}>
                                            <span className={styles.label}>上下文</span>
                                            <span className={styles.value}>{item.context}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={cn(styles.vertical, styles.price)}>
                                    <div>
                                        <span>{item.modelType === 'video' ? '9月3日前' : '输入价格'}</span>
                                        <span>{item.price.input}</span>
                                    </div>
                                    {item.modelType === 'video' || item.price.output ? (
                                        <div>
                                            <span>{item.modelType === 'video' ? '9月3日后' : '输出价格'}</span>
                                            <span>{item.price.output}</span>
                                        </div>
                                    ) : null}
                                </div>
                                <NormalSpanBtn data={item.btn} />
                            </a>
                        );
                    })}
                </div>
            </div>
            <div className={cn(styles['bottom-btn'], `${moduleContentCn}`)}>
                <ArrowBtn data={{...bottomBtn, secondary: true, trackInfo: bottomBtn.trackInfo}} />
            </div>
        </div>
    );
};

export default ModelsService;
